<script setup lang="ts">
import SecretManagementPanel from '../components/SecretManagementPanel.vue';
</script>

<template>
  <main class="content-page">
    <SecretManagementPanel />
  </main>
</template>
